export const orderStatusData = [
  { id: 'range1', value: 'all', label: 'All', name: 'order-status' },
  { id: 'range2', value: 'started', label: 'Started', name: 'order-status' },
  { id: 'range3', value: 'completed', label: 'Completed', name: 'order-status' },
];

export const operationStatusData = [
  { id: 'checkbox1', label: 'Violation', name: 'operation-status', value: 'violation' },
  { id: 'checkbox2', label: 'No data', name: 'operation-status', value: 'no data' },
  { id: 'checkbox3', label: 'Compliance', name: 'operation-status', value: 'compliance' },
];
